import React from "react";
import Quotes from "./Dashboard/Quotes/Quotes";

function App() {
  return (
    <div className="App flex justify-center">
      <Quotes />
    </div>
  );
}

export default App;
